import * as bootstrap from 'bootstrap';
import jsKit from '../../../shared/modules/jsKit';
import sp from '../../../shared/modules/sp';

const getBootstrap = () => bootstrap;
const getDataParts = (target, dataItem) => jsKit.getDataParts(target, dataItem);
const getElement = (selector, parent = document) => {
  const root = typeof parent === 'string' ? document.querySelector(parent) : parent;
  return root ? root.querySelector(selector) : null;
};

const showElement = (element) => {
  if (!element) {
    return;
  }

  element.style.removeProperty('display');
};

const hideElement = (element) => {
  if (!element) {
    return;
  }

  element.style.display = 'none';
};

function closeProductOptions(el) {
  if (!el) {
    return;
  }

  const basketModal = el.closest('[data-basket-product-add]');
  if (!basketModal) {
    return;
  }

  basketModal.querySelectorAll('[data-product-options] .btn-check:not([data-default-checked])').forEach((input) => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  basketModal.addEventListener('hidden.bs.modal', () => {
    const basketContent = getElement('[data-product-basket-content]', basketModal);
    const productOptions = getElement('[data-product-options]', basketModal);

    if (basketContent) {
      basketContent.innerHTML = '';
      hideElement(basketContent);
    }

    showElement(productOptions);
  });
}

async function reloadBasketTeaser() {
  const teaser = getElement('#basket-teaser');
  if (!teaser) {
    return;
  }

  const data = await jsKit.requestUrl('/basket/loadBasketTeaser', 'text');
  if (typeof data !== 'undefined') {
    teaser.innerHTML = data;
  }
}

async function addWholesaleProductToBasket(productId, overlay) {
  if (!productId) {
    return;
  }

  const dataForm = new URLSearchParams();
  const personalizationRoot = overlay || document;
  dataForm.append('add_wholesale_product[personalization_title]', getElement('#personalize-title', personalizationRoot)?.value || '');
  dataForm.append('add_wholesale_product[personalization_number]', getElement('#personalize-number', personalizationRoot)?.value || '');
  dataForm.append('add_wholesale_product[personalization_line1]', getElement('#personalize-line1', personalizationRoot)?.value || '');
  dataForm.append('add_wholesale_product[personalization_line2]', getElement('#personalize-line2', personalizationRoot)?.value || '');
  dataForm.append('add_wholesale_product[personalization_line3]', getElement('#personalize-line3', personalizationRoot)?.value || '');
  dataForm.append('add_wholesale_product[product_id]', productId);

  document.querySelectorAll("[id^='product_option_']").forEach((input) => {
    if (input.value) {
      dataForm.append(`add_wholesale_product[amount][${input.name}]`, input.value);
    }
  });

  document.querySelectorAll('.glyphicon.glyphicon-exclamation-sign').forEach((icon) => icon.remove());

  const data = await jsKit.requestUrl('/basket/addWholesaleProduct', 'urlencoded', 'POST', dataForm);
  if (data && data.validated) {
    if (data.added) {
      await reloadBasketTeaser();
    }

    document.querySelectorAll("[id^='product_option_']").forEach((input) => {
      input.value = '';
      sp.wholesaleAmountChange(input);
    });

    const productOptions = getElement('[data-product-options]', `[data-shop="product-${productId}-options"]`);
    const productBasketContent = getElement('[data-product-basket-content]', `[data-shop="product-${productId}-options"]`);
    hideElement(productOptions);
    if (productBasketContent) {
      productBasketContent.innerHTML = data.content || '';
      showElement(productBasketContent);
    }

    const bootstrap = getBootstrap();
    if (bootstrap && overlay) {
      const overlayElement = overlay.nodeType ? overlay : overlay[0];
      if (overlayElement) {
        const optionsModalInstance = new bootstrap.Modal(overlayElement);
        overlayElement.addEventListener('shown.bs.modal', () => {
          document.body.removeAttribute('style');
        });
        optionsModalInstance.show();
      }
    }
  } else {
    window.showErrors(data);
  }
}

async function addWholesalePopupProductToBasket(productId) {
  if (!productId) {
    return;
  }

  const dataForm = new URLSearchParams();
  const productRoot = getElement(`#prodID_${productId}`) || document;
  dataForm.append('add_wholesale_product[product_id]', productId);

  productRoot.querySelectorAll("[id^='attribute-product_option_']").forEach((input) => {
    if (input.value) {
      dataForm.append(`add_wholesale_product[amount][${input.name}]`, input.value);
    }
  });

  const data = await jsKit.requestUrl('/basket/addWholesaleProduct', 'urlencoded', 'POST', dataForm);
  if (data && data.validated) {
    if (data.added) {
      await reloadBasketTeaser();
    }

    document.querySelectorAll("[id^='product_option_']").forEach((input) => {
      input.value = '';
      sp.wholesaleAmountChange(input);
    });

    const productOptions = getElement('[data-product-options]', `[data-shop="product-${productId}-options"]`);
    const productBasketContent = getElement('[data-product-basket-content]', `[data-shop="product-${productId}-options"]`);
    hideElement(productOptions);
    if (productBasketContent) {
      productBasketContent.innerHTML = data.content || '';
      showElement(productBasketContent);
    }
  } else {
    alert(data.error_message);
  }
}

function wholesalePopupAmountChange(elem, maxStockAmount, productId) {
  jsKit.sanitizeInteger(elem, undefined, parseInt(maxStockAmount, 10));

  if (elem.value == '0') {
    elem.value = '';
  }

  const optionId = elem.name;

  const checkbox = getElement(`#attribute-checkbox_${optionId}`, `#prodID_${productId}`);
  if (checkbox) {
    checkbox.checked = !(elem.value == 0 || elem.value == '');
  }
}

function showWholesaleProductOptions(e) {
  const bootstrap = getBootstrap();
  if (!bootstrap) {
    return;
  }

  const btn = e.delegateTarget || e.currentTarget;
  const product = btn.closest('[data-shop="product-container"]');
  const optionsModal = getElement('[data-basket-product-add]', product);
  if (!optionsModal) {
    return;
  }

  const optionsModalInstance = new bootstrap.Modal(optionsModal);
  const preselected = getElement('.btn-check:checked', product);

  optionsModal.querySelectorAll('.btn-check:not([data-default-checked])').forEach((input) => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  if (preselected) {
    const option = optionsModal.dataset.shop.split('-');
    addWholesaleProductToBasket(option[1], optionsModal);
  } else {
    optionsModal.addEventListener('shown.bs.modal', () => {
      document.body.removeAttribute('style');
    });
    optionsModalInstance.show();
    showElement(getElement('[data-product-options]', optionsModal));
  }
}

export const productBasketEvents = [
  ['jsShowWholesaleProductOptions', (e) => {
    e.preventDefault();
    showWholesaleProductOptions(e);
  }],

  ['jsCloseProductOptions', (e) => {
    e.preventDefault();
    closeProductOptions(e.delegateTarget);
  }],

  ['jsAddWholesalePopupProductToBasket', (e) => {
    e.preventDefault();
    addWholesalePopupProductToBasket(e.delegateTarget.dataset.jsAddWholesalePopupProductToBasket);
  }],

  ['jsWholesalePopupAmountChange', (e) => {
    const [maxStockAmount, productId] = getDataParts(e.delegateTarget, 'jsWholesalePopupAmountChange');
    wholesalePopupAmountChange(e.delegateTarget, maxStockAmount, productId);
  }, 'keyup'],
];
